import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLIC_KEY } from 'config';
import UpdatePaymentMethodForm from '../UpdatePaymentMethodForm';

// Initialize Stripe
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY!);

interface Props {
  open: boolean;
  onClose: () => void;
  customerId: string;
}

const UpdatePaymentMethodModal = ({ open, onClose, customerId }: Props) => {
  const handleSuccess = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="update-payment-method-dialog"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="update-payment-method-dialog">
        Update Payment Method
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Elements
          stripe={stripePromise}
          options={{
            appearance: {
              theme: 'stripe',
            },
          }}
        >
          <UpdatePaymentMethodForm
            customerId={customerId}
            onSuccess={handleSuccess}
            onCancel={onClose}
          />
        </Elements>
      </DialogContent>
    </Dialog>
  );
};

export default UpdatePaymentMethodModal; 